import { createContext, useContext } from 'react';
export const ProductErrorContext = /*#__PURE__*/createContext(undefined);
export const useProductErrors = () => {
  const context = useContext(ProductErrorContext);
  if (context === undefined) {
    throw new Error('ProductErrorContext data is undefined. useProductErrors must be used within a ProductErrorContext');
  }
  return context;
};